// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formContainer {
  margin: 30px; }

.faqHeader {
  margin: 40px 0; }

.formFields {
  width: 50%;
  margin: 0 0 30px 70px; }

.sectionBtn {
  margin-top: 20px;
  display: flex;
  justify-content: space-between; }
  .sectionBtn .ant-btn {
    background: #586f80;
    border-radius: 4px;
    height: 28px;
    color: white;
    font-weight: 600;
    text-align: center;
    border: none !important;
    transition: all 0.5s linear;
    margin: 0px 10px; }
  .sectionBtn .ant-btn:hover {
    background: #586f80;
    border-radius: 4px;
    height: 28px;
    color: white;
    font-weight: 600;
    text-align: center;
    border: none !important;
    transition: all 0.5s linear;
    margin: 0px 10px; }
  .sectionBtn .deleteBtn {
    background: #ec4747;
    border-radius: 4px;
    height: 28px;
    color: white;
    font-weight: 600;
    text-align: center;
    border: none !important;
    transition: all 0.5s linear;
    margin: 0px 10px; }

#faqBtn {
  background: #586f80;
  border-radius: 4px;
  height: 28px;
  color: white;
  font-weight: 600;
  text-align: center;
  border: none !important;
  transition: all 0.5s linear;
  margin: 0px 10px;
  padding: 0 12px; }

#faqDeleteBtn {
  background: #ec4747;
  border-radius: 4px;
  height: 28px;
  color: white;
  font-weight: 600;
  text-align: center;
  border: none !important;
  transition: all 0.5s linear;
  margin: 0px 10px;
  padding: 0 12px; }

.ant-table-cell {
  text-align: center; }

.ant-table-thead tr .ant-table-cell {
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/pages/Faqs/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAY,EAAA;;AAGhB;EACI,cAAc,EAAA;;AAGlB;EACI,UAAU;EACV,qBAAqB,EAAA;;AAGzB;EACI,gBAAgB;EAChB,aAAa;EACb,8BAA8B,EAAA;EAHlC;IAMQ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB,EAAA;EAdxB;IAkBQ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB,EAAA;EA1BxB;IA8BQ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB,EAAA;;AAIxB;EACI,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,kBAAkB,EAAA;;AAGtB;EACI,kBAAkB,EAAA","sourcesContent":[".formContainer {\n    margin: 30px;\n}\n\n.faqHeader {\n    margin: 40px 0;\n}\n\n.formFields {\n    width: 50%;\n    margin: 0 0 30px 70px;\n}\n\n.sectionBtn {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n\n    .ant-btn {\n        background: #586f80;\n        border-radius: 4px;\n        height: 28px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        border: none !important;\n        transition: all 0.5s linear;\n        margin: 0px 10px;\n    }\n\n    .ant-btn:hover {\n        background: #586f80;\n        border-radius: 4px;\n        height: 28px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        border: none !important;\n        transition: all 0.5s linear;\n        margin: 0px 10px;\n    }\n\n    .deleteBtn {\n        background: #ec4747;\n        border-radius: 4px;\n        height: 28px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        border: none !important;\n        transition: all 0.5s linear;\n        margin: 0px 10px;\n    }\n}\n\n#faqBtn {\n    background: #586f80;\n    border-radius: 4px;\n    height: 28px;\n    color: white;\n    font-weight: 600;\n    text-align: center;\n    border: none !important;\n    transition: all 0.5s linear;\n    margin: 0px 10px;\n    padding: 0 12px;\n}\n\n#faqDeleteBtn {\n    background: #ec4747;\n    border-radius: 4px;\n    height: 28px;\n    color: white;\n    font-weight: 600;\n    text-align: center;\n    border: none !important;\n    transition: all 0.5s linear;\n    margin: 0px 10px;\n    padding: 0 12px;\n}\n\n.ant-table-cell {\n    text-align: center;\n}\n\n.ant-table-thead tr .ant-table-cell {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
